import { CheckSquare } from "lucide-react";

// Four-step indicator that sits above the wizard body.
// Rendered only when the wizard has advanced past step 1 (legacy behaviour).
export default function WizardStepsIndicator({ wizardStep }) {
  if (wizardStep <= 1) return null;

  const steps = [
    { index: 1, label: "Role Creation" },
    { index: 2, label: "Fetch Access" },
    { index: 3, label: "Screen Access" },
    { index: 4, label: "Data Access" },
  ];

  return (
    <div className="flex items-center justify-center p-4 border-b-2 border-gray-300 bg-gray-50">
      <div className="flex items-center space-x-2">
        {steps.map((step, idx) => (
          <div key={step.index} className="flex items-center">
            <div
              className={`flex items-center ${
                wizardStep >= step.index ? "text-redhalo-navy" : "text-gray-400"
              }`}
            >
              <div
                className={`w-8 h-8 rounded-full border-2 flex items-center justify-center ${
                  wizardStep >= step.index
                    ? "border-redhalo-red bg-redhalo-mint/50"
                    : "border-gray-300"
                }`}
              >
                {wizardStep > step.index ? (
                  <CheckSquare className="w-5 h-5" />
                ) : (
                  <span>{step.index}</span>
                )}
              </div>
              <span className="ml-2 text-sm font-medium">{step.label}</span>
            </div>
            {idx < steps.length - 1 && (
              <div className="w-12 h-0.5 bg-gray-300 mx-2"></div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
